import Context from './Context.js';
import ArgumentValidator from '../argumentValidator/ArgumentValidator.js';
import StringHelper from '../helpers/StringHelper.js';
import ObjectHelper from '../helpers/ObjectHelper.js';

export default class Vehicle extends Context {
  static get key() {
    return 'vehicle_event_context'
  }

  static get version() {
    return '1-4-0';
  }

  isArabic(text) {
    return /[\u0600-\u06FF\u0750-\u077F]/.test(text);
  }

  removeNotAllowedCharacters(text) {
    return text.replace(/[^a-z|^A-Z|^\d+|^'|^\-|^\s]/g, '');
  }

  normalizeString(text) {
    if (typeof text === 'string' && !this.isArabic(text)) {
      return this.removeNotAllowedCharacters(text);
    }
    return text;
  }

  normalizeNumber(number) {
    if (typeof number === 'string') {
      number.replace(',', '.');
    }
    return Number(number) || null;
  }

  setCurrency(currency) {
    this.data.ve_cu = currency;
    return this;
  }

  setType(type) {
    this.data.ve_ty = type;
    return this;
  }

  setId(id) {
    new ArgumentValidator('id', id).verifyTypesOf(['number', 'string']).verifyThatMatchesRegExp(/^\d+$/);
    this.data.ve_id = Number(id);
    return this;
  }

  setManufacturer(manufacturer) {
    this.data.ve_ma = this.normalizeString(manufacturer);
    return this;
  }

  setModel(model) {
    this.data.ve_mo = this.normalizeString(model);
    return this;
  }

  setVariant(variant) {
    this.data.ve_va = variant;
    return this;
  }

  setFranchiseApproved(isApproved) {
    this.data.ve_fr_ap = Boolean(isApproved);
    return this;
  }

  setPrice(price) {
    this.data.ve_pr = this.normalizeNumber(price);
    return this;
  }

  setRegistrationDate(date) {
    this.data.ve_rd = date;
    return this;
  }

  setColour(colour) {
    this.data.ve_co = this.normalizeString(colour);
    return this;
  }

  setBodyStyle(bodyStyle) {
    this.data.ve_bs = this.normalizeString(bodyStyle);
    return this;
  }

  setFuelType(fuelType) {
    this.data.ve_ft = this.normalizeString(fuelType);
    return this;
  }

  setTransmission(transmission) {
    this.data.ve_tr = this.normalizeString(transmission);
    return this;
  }

  setEngineSize(engineSize) {
    this.data.ve_el = this.normalizeNumber(engineSize);
    return this;
  }

  setCombinedMpg(combinedMpg) {
    this.data.ve_ec_mg = this.normalizeNumber(combinedMpg);
    return this;
  }

  setEfficiencyUnit(unit) {
    this.data.ve_ec_un = unit;
    return this;
  }

  setTaxBand(taxBand) {
    this.data.ve_ec_tx = this.normalizeString(taxBand);
    return this;
  }

  setEquipment(equipment) {
    this.data.ve_eq = equipment;
    return this;
  }

  setGroupHash(groupHash) {
    this.data.ve_gr = groupHash;
    return this;
  }

  setFranchiseHash(franchiseHash) {
    this.data.ve_fr = franchiseHash;
    return this;
  }

  setLocationHash(locationHash) {
    this.data.ve_lo = locationHash;
    return this;
  }

  setGuid(guid) {
    this.data.vehicle_guid = guid;
    return this;
  }

  importData(data) {
    new ArgumentValidator('data', data).verifyInstanceOf(Object);
    if (data.id) {
      this.setId(data.id);
    }
    if (data.type) {
      this.setType(data.type);
    }
    if (data.manufacturer) {
      this.setManufacturer(data.manufacturer);
    }
    if (data.model) {
      this.setModel(data.model);
    }
    if (data.variant) {
      this.setVariant(data.variant);
    }
    if (data.franchise_approved) {
      this.setFranchiseApproved(data.franchise_approved);
    }
    if (data.registration_date) {
      this.setRegistrationDate(data.registration_date);
    }
    if (data.price) {
      this.setPrice(data.price);
    }
    if (data.colour) {
      this.setColour(data.colour);
    }
    if (data.body_style) {
      this.setBodyStyle(data.body_style);
    }
    if (data.fuel_type) {
      this.setFuelType(data.fuel_type);
    }
    if (data.transmission) {
      this.setTransmission(data.transmission);
    }
    if (data.engine_size) {
      this.setEngineSize(data.engine_size);
    }
    if (data.combined_mpg) {
      this.setCombinedMpg(data.combined_mpg);
    }
    if (data.efficiency_unit) {
      this.setEfficiencyUnit(data.efficiency_unit);
    }
    if (data.tax_band) {
      this.setTaxBand(data.tax_band);
    }
    if (data.equipment) {
      this.setEquipment(data.equipment);
    }
    if (data.group_hash) {
      this.setGroupHash(data.group_hash);
    }
    if (data.franchise_hash) {
      this.setFranchiseHash(data.franchise_hash);
    }
    if (data.location_hash) {
      this.setLocationHash(data.location_hash);
    }
    if (data.currency) {
      this.setCurrency(data.currency);
    }
    if (data.vehicle_guid) {
      this.setGuid(data.vehicle_guid);
    }
    return this;
  }

  export() {
    this.dataToLowerCase();
    return super.export()
  }

  dataToLowerCase() {
    ObjectHelper.map(this.data, value => StringHelper.toLowerCase(value));
  }
}
